import React, { useState, useRef, useCallback } from "react";

const DebouncedInput = ({
    value: initialValue,
    onChange,
    debounce = 500,
    type,
    ...props
}: {
    value: string | number;
    onChange: (value: string | number) => void;
    debounce?: number;
    type: string;
} & Omit<React.InputHTMLAttributes<HTMLInputElement>, "onChange">) => {
    const [value, setValue] = useState(initialValue);
    const timeoutRef = useRef<number | null>(null);

    const handleInputChange = useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
            const newValue = e.target.value;
            setValue(newValue);

            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }

            // @ts-expect-error: expceted
            timeoutRef.current = setTimeout(() => {
                onChange(newValue);
            }, debounce);
        },
        [debounce, onChange]
    );

    return (
        <input
            {...props}
            type={type}
            className="form-control mb-0"
            value={value}
            onChange={handleInputChange}
        />
    );
};

export default DebouncedInput;
